/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { connect } from 'react-redux';
import { formatDateForInput } from 'utilities/common';
import { formatMoney } from 'utilities/currencyFormatter';
import { makeStyles } from '@material-ui/styles';
import { showToast } from 'modules/layout/layout.actions';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import SpinnerComponent from 'modules/common/spinner.component';
import { ValueType } from './expenseLineItemsUtils';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';

const useStyles = makeStyles(theme => ({
  card: { width: '100%', flexGrow: 1, flexDirection: 'row', justifyContent: 'space-between' },
  cardContainer: { maxWidth: '100% !important', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  iconRow: { display: 'flex', flexDirection: 'row' },
  dialogIconRow: { display: 'flex', flexDirection: 'row', padding: '40px', paddingBottom: '20px' },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: { marginRight: theme.spacing(1), marginBottom: theme.spacing(1) },
  chipClickable: { cursor: 'pointer' },
  iconOverlayImg: { position: 'absolute', zIndex: '1 !important' },
  spacingX: { marginRight: theme.spacing(1) },
  footer: { height: 15, marginBottom: theme.spacing(2) },
  mb2: { marginBottom: '4px', marginRight: '16px' },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: { display: 'flex', flexDirection: 'column', width: '100% !important' },
  editModalInput: { minWidth: '332px' },
  dialogContentContainer: { margin: '15px' },
  labelText: { minWidth: 350, marginBottom: 0 }
}));

const getEnumLabel = (id, options) => {
  if (!id) return '';
  const match = (options ?? []).find(o => o.id === id);
  return match?.title ?? '';
};

const ExpenseLineItemsPayrollEditableCard = props => {
  const { updateFields, isLoading, selectedExpenseLineItem, enumerations } = props;
  const classes = useStyles();

  const theme = createTheme({
    palette: { primary: COLOR_PRIMARY, secondary: COLOR_SECONDARY, warning: COLOR_WARNING }
  });

  const payrollTypeOptions = useMemo(() => (enumerations?.payrollTypes ?? []).filter(p => p.isActive), [enumerations]);
  const stateOptions = useMemo(() => (enumerations?.provinces ?? []).filter(s => s.isActive), [enumerations]);

  const createTableValues = () => ({
    'Original (1.45%)': {
      taxAssistanceAmount: selectedExpenseLineItem?.medicareTaxAssistanceOriginalAmount,
      withholdingAmount: selectedExpenseLineItem?.medicareWithholdingOriginalAmount
    },
    'Surtax (0.9%)': {
      taxAssistanceAmount: selectedExpenseLineItem?.medicareTaxAssistanceSurtaxAmount,
      withholdingAmount: selectedExpenseLineItem?.medicareWithholdingSurtaxAmount
    }
  });

  const rowNames = ['Original (1.45%)', 'Surtax (0.9%)'];

  const [editingModalOpen, setEditingModalOpen] = useState(false);

  const handleSaveEdits = async (_authId, values) => {
    if (!updateFields) return;
    const resp = await updateFields(_authId, values);
    if (!resp) {
      showToast('Failed to update card data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }
    setEditingModalOpen(false);
  };

  const handleCancelEdits = () => setEditingModalOpen(false);

  const renderHeader = () => (
    <div className="row justify-space-between align-center">
      <div className={classes.iconRow}>
        <Tooltip title="Payroll" key={'Payroll'} placement="right">
          <FontAwesomeIcon icon={['fas', 'money-bill-transfer']} size="2x" />
        </Tooltip>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px', paddingLeft: '20px' }}>
          <Typography variant="h5" sx={{ fontSize: '1.3125rem', fontWeight: 'bold' }}>
            Payroll
          </Typography>
        </Box>
      </div>
      {!props.viewOnly && (
        <Fab className={classes.iconOverlayImg} color="primary" size="small" onClick={() => setEditingModalOpen(true)}>
          <FontAwesomeIcon size="1x" icon={['fas', 'pen']} color={theme.palette.common.white} />
        </Fab>
      )}
    </div>
  );

  const parseValueForGrid = val => {
    if (val === null || val === undefined || isNaN(val)) return '--';
    const parsed = parseFloat(val);
    if (isNaN(parsed)) return '--';
    return formatMoney(parsed);
  };

  const renderOption = (value, valueType, header) => (
    <Grid item xs={2} sm={2} md={2} xl={2}>
      <Box>
        <div className={classes.mb2}>
          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
            {header}
          </Typography>
        </div>
        {valueType === ValueType.DateTimeType && (
          <div className={classes.mb2}>
            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
              {value ? new Date(value).toLocaleDateString('en-us') : <div>&mdash;</div>}
            </Typography>
          </div>
        )}
        {valueType === ValueType.MoneyType && (
          <div className={classes.mb2}>
            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
              {value ? formatMoney(value) : <div>&mdash;</div>}
            </Typography>
          </div>
        )}
        {valueType === ValueType.StringType && (
          <div className={classes.mb2}>
            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
              {value ? value : <div>&mdash;</div>}
            </Typography>
          </div>
        )}
      </Box>
    </Grid>
  );

  const renderEditableCardTable = values => (
    <Box sx={{ padding: '20px' }}>
      <Grid container spacing={2}>
        <Grid item xs={3}></Grid>
        <Grid item xs={4}>
          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', whiteSpace: 'nowrap' }}>
            Medicare Tax Assist
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', whiteSpace: 'nowrap' }}>
            Medicare Withholding
          </Typography>
        </Grid>
        {rowNames.map(name => (
          <React.Fragment key={name}>
            <Grid item xs={4}>
              <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                {name}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                {parseValueForGrid(values[name].taxAssistanceAmount)}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                {parseValueForGrid(values[name].withholdingAmount)}
              </Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );

  return (
    <ThemeProvider theme={theme}>
      <Card className={classes.card} sx={{ position: 'relative' }}>
        <Box>
          <CardContent className={classes.cardContainer}>{renderHeader()}</CardContent>
          <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
            <Grid container spacing={2} columns={{ xs: 6 }}>
              {renderOption(selectedExpenseLineItem?.stateExcludableAmount, ValueType.MoneyType, 'State Excludable')}
              {renderOption(selectedExpenseLineItem?.payrollInProcessDate, ValueType.DateTimeType, 'Payroll in Process')}
              {renderOption(selectedExpenseLineItem?.payrollPostedDate, ValueType.DateTimeType, 'Payroll Posted')}
              {renderOption(getEnumLabel(selectedExpenseLineItem?.payrollTypeId, payrollTypeOptions), ValueType.StringType, 'Payroll Type')}
              {renderOption(getEnumLabel(selectedExpenseLineItem?.taxStateId, stateOptions), ValueType.StringType, 'Tax State')}
              {renderOption(selectedExpenseLineItem?.payAmount, ValueType.MoneyType, 'Pay Amount')}

              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Box sx={{ paddingTop: '10px' }}>{renderEditableCardTable(createTableValues())}</Box>
            </Grid>
          </CardContent>
        </Box>
      </Card>

      {editingModalOpen && (
        <EditCardModal
          selectedExpenseLineItem={selectedExpenseLineItem}
          classes={classes}
          open={editingModalOpen}
          isLoading={isLoading}
          onClose={handleCancelEdits}
          onSubmit={handleSaveEdits}
          enumerations={enumerations}
          payrollTypeOptions={payrollTypeOptions}
          stateOptions={stateOptions}
        />
      )}
    </ThemeProvider>
  );
};

ExpenseLineItemsPayrollEditableCard.propTypes = {
  tabs: PropTypes.array,
  summaries: PropTypes.array,
  updateFields: PropTypes.func.isRequired,
  showToast: PropTypes.func.isRequired
};

export default connect(null, { showToast })(ExpenseLineItemsPayrollEditableCard);

export const EditCardModal = ({
  selectedExpenseLineItem,
  classes,
  onClose,
  onSubmit,
  isLoading,
  open,
  enumerations,
  payrollTypeOptions,
  stateOptions
}) => {
  const [values, setValues] = useState(selectedExpenseLineItem);

  useEffect(() => {
    setValues(selectedExpenseLineItem);
  }, [selectedExpenseLineItem]);

  const handleChange = e => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const payload = {
      ...values,
      payrollTypeId: !values?.payrollTypeId || values?.payrollTypeId === '' ? ZERO_GUID : values.payrollTypeId
    };
    onSubmit(payload);
  };

  const handleCancel = e => {
    e.preventDefault();
    onClose();
  };

  return (
    <Dialog open={open} fullWidth maxWidth="lg">
      <form onSubmit={handleSubmit}>
        <div className="row justify-space-between align-center">
          <div className={classes.dialogIconRow}>
            <Tooltip title="Payroll" key="Payroll" placement="right">
              <FontAwesomeIcon icon={['fas', 'money-bill-transfer']} size="3x" />
            </Tooltip>
            <Typography variant="h5" sx={{ paddingLeft: '20px' }}>
              Payroll
            </Typography>
          </div>
        </div>

        <div className={classes.dialogContentContainer}>
          <Stack sx={{ width: '100%', minWidth: { xs: '300px' }, gap: '1.5rem' }}>
            <Grid container spacing={{ xs: 2 }} sx={{ padding: '30px', paddingTop: '0px' }}>
              <Grid item>
                <TextField
                  label="State Excludable"
                  name="stateExcludableAmount"
                  value={values?.stateExcludableAmount ?? ''}
                  margin="dense"
                  variant="standard"
                  sx={{ maxWidth: '360px' }}
                  type="number"
                  InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item>
                <TextField
                  label="Payroll In Process"
                  name="payrollInProcessDate"
                  value={formatDateForInput(values?.payrollInProcessDate)}
                  margin="dense"
                  sx={{ maxWidth: '360px' }}
                  variant="standard"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item>
                <TextField
                  label="Payroll Posted"
                  name="payrollPostedDate"
                  value={formatDateForInput(values?.payrollPostedDate)}
                  margin="dense"
                  sx={{ maxWidth: '360px' }}
                  variant="standard"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item>
                <FormControl sx={{ marginTop: '6px' }}>
                  <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Payroll Type</InputLabel>
                  <Select
                    label="Payroll Type"
                    name="payrollTypeId"
                    value={values?.payrollTypeId ?? ''}
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                    onChange={handleChange}
                  >
                    <MenuItem value={ZERO_GUID}>(None)</MenuItem>
                    {payrollTypeOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item>
                <FormControl sx={{ marginTop: '6px' }}>
                  <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Tax State</InputLabel>
                  <Select
                    label="Tax State"
                    name="taxStateId"
                    value={values?.taxStateId ?? ZERO_GUID}
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                    onChange={handleChange}
                  >
                    {stateOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <TextField
                  label="Pay Amount"
                  name="payAmount"
                  value={values?.payAmount ?? ''}
                  margin="dense"
                  variant="standard"
                  sx={{ maxWidth: '360px' }}
                  type="number"
                  InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                  onChange={handleChange}
                />
              </Grid>
              <Box sx={{ padding: '10px', maxWidth: '800px', paddingTop: '20px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}></Grid>
                  <Grid item xs={4}>
                    <Typography variant="subtitle2" sx={{ maxWidth: '360px', color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Medicare Tax Assist
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="subtitle2" sx={{ maxWidth: '360px', color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Medicare Withholding
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle2"
                      sx={{ paddingTop: '10px', maxWidth: '360px', color: '#777667', fontWeight: 400, fontSize: '1rem' }}
                    >
                      Original (1.45%)
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Tax Assistance Original"
                      name="medicareTaxAssistanceOriginalAmount"
                      value={values?.medicareTaxAssistanceOriginalAmount ?? ''}
                      margin="dense"
                      sx={{ maxWidth: '360px' }}
                      variant="standard"
                      type="number"
                      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Withholding Original"
                      name="medicareWithholdingOriginalAmount"
                      value={values?.medicareWithholdingOriginalAmount ?? ''}
                      margin="dense"
                      sx={{ maxWidth: '360px' }}
                      variant="standard"
                      type="number"
                      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle2"
                      sx={{ paddingTop: '10px', maxWidth: '360px', color: '#777667', fontWeight: 400, fontSize: '1rem' }}
                    >
                      Surtax (0.9%)
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Tax Assistance Surtax"
                      name="medicareTaxAssistanceSurtaxAmount"
                      value={values?.medicareTaxAssistanceSurtaxAmount ?? ''}
                      margin="dense"
                      sx={{ maxWidth: '360px' }}
                      variant="standard"
                      type="number"
                      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Withholding Surtax"
                      name="medicareWithholdingSurtaxAmount"
                      value={values?.medicareWithholdingSurtaxAmount ?? ''}
                      margin="dense"
                      sx={{ maxWidth: '360px' }}
                      variant="standard"
                      type="number"
                      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Stack>
        </div>

        {isLoading ? (
          <DialogActions sx={{ p: '1.25rem' }}>
            <SpinnerComponent />
          </DialogActions>
        ) : (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button color="primary" type="submit" variant="contained">
              Save
            </Button>
          </DialogActions>
        )}
      </form>
    </Dialog>
  );
};
